import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { aboutService } from '@/services/altingross';

// ─── Thunks ────────────────────────────────────────────────────────────────
export const fetchAbout = createAsyncThunk(
  'about/fetchSingle',
  async (_, { rejectWithValue }) => {
    try {
      const res = await aboutService.getSingle();
      return res.data;
    } catch (err) {
      // 404 → henüz kayıt yok, hata değil
      if (err?.response?.status === 404) return null;
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

export const saveAbout = createAsyncThunk(
  'about/save',
  async ({ data, isUpdate }, { rejectWithValue }) => {
    try {
      let res;
      if (isUpdate) {
        res = await aboutService.update(data.id, data);
      } else {
        res = await aboutService.create(data);
      }
      return res.data; // { id }
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  }
);

// ─── Slice ─────────────────────────────────────────────────────────────────
const aboutSlice = createSlice({
  name: 'about',
  initialState: {
    data:        null,   // mevcut about kaydı
    loading:     false,
    error:       null,
    saveLoading: false,
    saveError:   null,
  },
  reducers: {
    resetSaveError: (state) => {
      state.saveError = null;
    },
    // Kayıt oluşturulduktan sonra id'yi güncelle
    setAboutId: (state, action) => {
      if (state.data) state.data.id = action.payload;
      else state.data = { id: action.payload };
    },
  },
  extraReducers: (builder) => {
    // fetchAbout
    builder
      .addCase(fetchAbout.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchAbout.fulfilled, (state, action) => {
        state.loading = false;
        state.data    = action.payload; // null → kayıt yok (POST yapılacak)
      })
      .addCase(fetchAbout.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });

    // saveAbout
    builder
      .addCase(saveAbout.pending, (state) => {
        state.saveLoading = true;
        state.saveError   = null;
      })
      .addCase(saveAbout.fulfilled, (state, action) => {
        state.saveLoading = false;
        // İlk kez oluşturulduysa id'yi data'ya kaydet
        if (!state.data) state.data = {};
        if (action.payload?.id) state.data.id = action.payload.id;
      })
      .addCase(saveAbout.rejected, (state, action) => {
        state.saveLoading = false;
        state.saveError   = action.payload;
      });
  },
});

export const { resetSaveError, setAboutId } = aboutSlice.actions;
export default aboutSlice.reducer;
